import React from 'react';

import { ContentByLabelMacroHandler } from '@confluence/content-by-label-macro/entry-points/ContentByLabelMacroRenderer.ts';
import type { ContentByLabelMacroParams } from '@confluence/content-by-label-macro/entry-points/ContentByLabelMacroTypes.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';

import { NestedAdfRendererWrapperProvider } from '../NestedAdfRendererWrapper.tsx';

type ContentByLabelExtensionHandlerProps = ExtensionHandlerProps & {
	Renderer: React.FC<any>;
	appearance?: string;
	macroParams?: ContentByLabelMacroParams;
};

export const ContentByLabelExtensionHandler = ({
	Renderer,
	appearance,
	macroParams,
	...macroDefaultProps
}: ContentByLabelExtensionHandlerProps): React.JSX.Element => (
	<NestedAdfRendererWrapperProvider Renderer={Renderer} appearance={appearance}>
		{(RendererWrapper) => (
			<ContentByLabelMacroHandler
				macroDefaultProps={macroDefaultProps}
				macroParams={macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfRendererWrapperProvider>
);
